// eslint-disable-next-line import/prefer-default-export
export enum PlanStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  EXPIRED = 'expired'
}
